import React, {useState, useRef, useEffect} from "react";

// reactstrap components
import {
  Button, 
  Card, Table,
  Collapse,
  CardBody,
  CardFooter,
  FormGroup,
  Input,
  Row,
  Col,
  
} from "reactstrap";
import { useSelector } from 'react-redux'
import { connect } from 'react-redux'
import { profileFetch } from "actions/actions";
import Mlisting from './Mlisting'
import Vehicles from './Vehicles'
import Select from "react-select";
import {customStyles} from '../../helpers/mycomps'
import VfeatureTab from './VfeatureTab'
import MainCar from '../images/mainCarPlaceholder.png'
import Phcar1 from '../images/placeholdercar1.png'
import Phcar2 from '../images/placeholdercar2.png'
import Phcar3 from '../images/placeholdercar3.png'
import Phcar4 from '../images/placeholdercar4.png'
import Switch from "react-bootstrap-switch";
import CreateVInfo from './CreateVInfo'
import {fieldvalidator, filenamevalid, numtests, floattest, filenamevalidom, compressionsize, alphaspace} from '../../helpers/validate'
import Compressor from 'compressorjs';


const modelyears = [
 {value : 0 , label : '2025'},
  {value : 1 , label : '2024'},
  {value : 2 , label : '2023'},
  {value : 3 , label : '2022'},
  {value : 4 , label : '2021'},
  {value : 5 , label : '2020'},
  {value : 6 , label : '2019'},
  {value : 7 , label : '2018'},
  {value : 8 , label : '2017'},
  {value : 9 , label : '2016'},
  {value : 10 , label : '2015'},
  {value : 11 , label : '2015'}, 
  {value : 12 , label : '2014'}, 
  {value : 13 , label : '2013'},
  {value : 14 , label : '2012'}, 
  {value : 15 , label : '2011'}, 
  {value : 16 , label : '2010'}, 
  {value : 17 , label : '2009'},
  {value : 18 , label : '2008'},
  {value : 19 , label : '2007'},
  {value : 20 , label : '2006'},
  {value : 21 , label : '2005'},
  {value : 22 , label : '2004'},
  {value : 23 , label : '2003'},
  {value : 24 , label : '2002'},
  {value : 25 , label : '2001'},
  {value : 26 , label : '2000'},
  {value : 27 , label : '1999'},
  {value : 28 , label : '1998'},
  {value : 29 , label : '1997'},
  {value : 30 , label : '1996'},
  {value : 31 , label : '1995'},
  {value : 32 , label : '1994'},
  {value : 33 , label : '1993'},
  {value : 34 , label : '1992'},
  {value : 35 , label : '1991'},
  {value : 36 , label : '1990'}, 
  {value : 37 , label : '1989'}, 
  {value : 38 , label : '1988'},
  {value : 39 , label : '1987'},
  {value : 40 , label : '1986'},
  {value : 41 , label : '1985'}, 
  {value : 42 , label : '1984'},
  {value : 43 , label : '1983'}, 
  {value : 44 , label : '1982'}, 
  {value : 45 , label : '1981'}, 
  {value : 46 , label : '1980'}, 
  {value : 47 , label : '1979'}
]




function CreateV(props) {

  const hiddenFileInputM = useRef(null);
  const hiddenFileInput1 = useRef(null);
  const hiddenFileInput2 = useRef(null);
  const hiddenFileInput3 = useRef(null);
  const hiddenFileInput4 = useRef(null);

  const userinfo = useSelector(state => state.profileStore.profileData)
  const catlist  = useSelector(state => state.featureStore.featureData).map(x => {
  
    return {
          label :x.categoryName.en  , value : x.categoryCode, 
          labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
          features : x.features, unit : x.unit
        }
      })
    const [showProcessing , setShowProcessing] = useState(false)
    const [listswap , setListswap] = useState(false)
    const [mylist , setMylist] = useState([])
    const [vehicleList, setVehicleList] = useState([])
    const [vtypeList , setVtypeList] = useState([])
    const [btypeList , setBtypeList] = useState([])
    const [vehicle , setVehicle ] = useState({
      vid : "",
      luid : "",
      tluid: "",
      tuid : "",
      listingtype : "",
      categoryCode : "1", 
      category : {en : "", fr : "", ar : ""},
      bid : "",
      blogo : "",
      bname :   {en : "", fr : "", ar : ""},
      mname :  {en : "", fr : "", ar : ""},
      modelyear : {value : "", label :""},
      notes : "",
      vtypeCode : "",
      vtname : {en : "", fr : "", ar : ""},
      btypeCode : "",
      btname : {en : "", fr : "", ar : ""},
      features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}],
      insurence : true,
      intcolor  : "",
      extcolor : "",
      approxmiles : "",
      hourly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      fhourly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      fdaily : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      daily : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      fdaily : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      weekly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      fweekly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      monthly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      fmonthly :{amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
      additionalinfo : {en : "", fr : "", ar : ""},
      documentsrequiredresident : {en : "Emirates ID, Driving License", fr : "", ar : "الهوية الإماراتية، رخصة القيادة"},
      documentsrequiredtourist : {en : "Passport, International Driving License", fr : "", ar : "جواز السفر، رخصة القيادة الدولية"},
      imgmc : "",
      imgpc : ["","","",""],
      saliktollcharges : "0",
      securitydeposit : "0",
      refunddays : "30",
      mindriverage  : "18",
      trmcode : "",
      trmname : {en : "", fr : "", ar : ""},
      fuelcode : "",
      fuelname : {en : "", fr : "", ar : ""},
      mcertifications : "",
      mobilizationCharges : "",
      mfoodcharges : "",
      maccommodationcharges : "",
      mtransportcharges : ""

    })
    const [categories, setCategories] = useState({categoryCode : "", en : "", fr : "", ar : ""})
    const [featuresList, setFeatureslist] = useState([])
    const [features, setFeatures] = useState([])

    const [showft, setShowft] = useState(false)
    const [clp, setClp] = useState(false)
    const [vupdateMode, setvUpdateMode] = useState(false)
    
    const [{altmc, srcmc}, setImgmc] = useState({
      srcmc: MainCar,
      altmc: ''
    });
    const [filenamesmc, setFilenamesmc] = useState()
    
    const [{altpc1, srcpc1}, setImgpc1] = useState({
      srcpc1: Phcar1,
      altpc1: ''
    });
    const [filenamespc1, setFilenamespc1] = useState()
   
    const [{altpc2, srcpc2}, setImgpc2] = useState({
      srcpc2: Phcar2,
      altpc2: ''
    });
    const [filenamespc2, setFilenamespc2] = useState()
   

    const [{altpc3, srcpc3}, setImgpc3] = useState({
      srcpc3: Phcar3,
      altpc3: ''
    });
    const [filenamespc3, setFilenamespc3] = useState()
   
    
    const [{altpc4, srcpc4}, setImgpc4] = useState({
      srcpc4: Phcar4,
      altpc4: ''
    });
    const [filenamespc4, setFilenamespc4] = useState()

    const [filterby, setFilterby] = useState([])
    const [filterbyt, setFilterbyt] = useState({value : "" , label : ""})
    
    const [infom, setInfom] = useState(false)
    const [alert, setAlert] = React.useState(null);

  const [compressedFile, setCompressedFile] = useState(null);

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const errorhandler = (error) => {
    try{
      if(error.response.status === 401){
        props.swal("Unauthorized, please login again.").then(t => {
            props.history.push(`/auth/login`)
        })   
      }else{
        props.swal(error.response.data.message)
      }
    } catch(e){
      props.swal("error processing request at this time, please contact support.")
    } 
  
  }


  const handleCompressedUpload = (e, type) => {
      let qual = compressionsize(e)
      if(qual === 2){
        props.swal("Sorry, Image can not be larger then 5MB")
        return 
      }
      
      const image = e;
      //console.log("Before compression " + Number(e.size)/1024 + "Kb" )

    new Compressor(image, {
      quality: qual, // 0.6 can also be used, but its not recommended to go below.
      maxHeight : "300px",
      maxWidth : "600px",
      success: (compressedResult) => {
        // compressedResult has the compressed file.
        // Use the compressed file to upload the images to your server.      
        //setCompressedFile(compressedResult)  
        //console.log("Quality is : " + qual)
        console.log("After Compression " + Number(compressedResult.size)/1024 + "Kb" )
        if(type === "first"){
          console.log("This is first image")
          setFilenamespc1(compressedResult)
        }
        if(type === "second"){
          console.log("This is second image")
          setFilenamespc2(compressedResult)
        }
        if(type === "third"){
          console.log("This is third image")
          setFilenamespc3(compressedResult)
        }
        if(type === "fourth"){
          console.log("This is fourth image")
          setFilenamespc4(compressedResult)
        }
        if(type === "main"){
          console.log("This is main image")
          setFilenamesmc(compressedResult)
        }
        return compressedResult
      },
    });
  };


  
    useEffect(() => {
      let datax = []
      try{
        if(userinfo[0].cat_car_allowed) {
          datax.push({value : "1", label : "Cars"})
          
        }
        if(userinfo[0].cat_machines_allowed) {
          datax.push({value : "2", label : "Machines"})
        }
        if(userinfo[0].cat_yacht_allowed) {
          datax.push({value : "3", label : "Yacht"})
        }
        setFilterby(datax)
      }catch(e){}
      
     
    }, [userinfo])

    const filtercontrol = () => {
      return (
        <Select styles={customStyles} options = {filterby} onChange={g => {toggle(); setFilterbyt(g)}} />
      )
    }

    const populatebrands = () => {
        setShowProcessing(true)
        
        props.API.get(`tenant/vehicle`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            
           let data = res.data.map((aa,k) =>{

                 return {
                   id: k,
                   vid: aa.vid ,
                   categoryCode : aa.categoryCode,
                   categoryName: aa.category.en + " - " + aa.category.ar ,
                   brandName : aa.bname.en + " - " + aa.bname.ar, 
                   modelName : aa.mname.en + " - " + aa.mname.ar,
                   blogo : aa.blogo,
                   ac : aa,
                   actions: (
                       // we've added some custom button actions
                       <div className="actions-right">
                            <Button
                           onClick={() => {
                             let obj = data.find((o) => o.vid === aa.vid);
                        
                              setVehicle({...obj.ac, features : [], insurence : true, intcolor : "", extcolor : "", 
                              vtname : {en: "", fr: "", ar :""},
                              vtypeCode : "",
                              btname : {en: "", fr: "", ar :""},
                              btypeCode : "",
                              approxmiles : "", 
                              hourly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                              fhourly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                              daily : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},  
                              fdaily : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"}, 
                              weekly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                              fweekly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                              monthly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                              fmonthly : {amt : "0", mileq : "0", xmileq : "0", wdamt : "0"},
                               imgmc : "" ,
                               luid : "",
                                tluid: "",
                                tuid : "",
                                listingtype : "",
                                additionalinfo : {en : "", fr : "", ar : ""},
                                documentsrequiredresident : {en : "Emirates ID, Driving License", fr : "", ar : "الهوية الإماراتية، رخصة القيادة"},
                                documentsrequiredtourist : {en : "Passport, International Driving License", fr : "", ar : "جواز السفر، رخصة القيادة الدولية"},
                                imgmc : "",
                                imgpc : ["","","",""],
                                saliktollcharges : "0",
                                securitydeposit : "0",
                                refunddays : "30",
                                mindriverage  : "18",
                                trmcode : "",
                                trmname : {en : "", fr : "", ar : ""},
                                fuelcode : "",
                                fuelname : {en : "", fr : "", ar : ""}
                              })
                            //  console.log(catlist)
                        //      console.log(obj)
                         //     let feat = catlist.find(e => e.value === obj.categoryCode).features
                              setFeatureslist(catlist.find(e => e.value === obj.categoryCode).features.map(t => {
                                return {
                                ...t, value : t.featureCode, label: t.en, labelfr: t.fr, labelar : t.ar , unit : t.unit
                                }
                            })); 
                             setvUpdateMode(false)
                           }}
                           color="info"
                           size="sm"
                           className="btn-icon btn-link edit"
                         >
                          <i className="fa fa-edit" aria-hidden="true"></i>
                         </Button>    {' '}
   
                       </div>
                     ),
                    }
                }
            )
            setShowProcessing(false)
            setVehicleList(data)   
              
              ///////////////
            }).catch(function (error) {
              setShowProcessing(false)
              errorhandler(error)
                
            }) 
            setShowProcessing(true)
            props.API.get(`tenant/vtypes/${"-"}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.map(t => {
                     
                  return {
                    ...t, value : t.typeCode, label : t.typeName.en
                  } 
                })
                setShowProcessing(false)
                setVtypeList(data)   
                //console.log(res.data)
                                
              }).catch(function (error) {
                setShowProcessing(false)
                errorhandler.log(error)
               
                 
              })
            props.API.get(`tenant/btypes/${"-"}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.map(t => {
                     
                  return {
                    ...t, value : t.typeCode, label : t.typeName.en
                  } 
                })
                setShowProcessing(false)
                setBtypeList(data)   
                //console.log(res.data)
                                
              }).catch(function (error) {
                setShowProcessing(false)
                errorhandler.log(error)
               
                 
              })         
              
      }

    const mylisting = () => {
      
      setShowProcessing(true)
      props.API.get(`ten/mylisting/${props.user.tuid}`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        let data = res.data.map((aa,k) =>{
          console.log(aa.btname)
          console.log(aa.tluid)
          return {
            id: k,
            ac : aa,
            actions: (
                // we've added some custom button actions
                <div className="actions-right">
                     <Button
                    onClick={() => {
                      let obj = data.find((o) => o.id === k);
                       setVehicle({...obj.ac})
                       
                       setFeatureslist(catlist.find(e => e.value === obj.ac.categoryCode).features.map(t => {
                         return {
                         ...t, value : t.featureCode, label: t.en, labelfr: t.fr, labelar : t.ar , unit : t.unit
                         }
                     }));  
                     setvUpdateMode(true)
                    }}
                    color="info"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                   <i className="fa fa-edit" aria-hidden="true"></i>
                  </Button> 
                  <Button
                    onClick={() => {
                      
                      let obj = data.find((o) => o.id === k);
                      setVehicle({...obj.ac})
                      setvUpdateMode(true)
                     setInfom(true)
                    }}
                    color="info"
                    size="sm"
                    className="btn-icon btn-link edit"
                  >
                   <i className="fa fa-info" aria-hidden="true"></i>
                  </Button> 

                </div>
              ),
             }
         }
     )
        
        setMylist(data)
        setShowProcessing(false)             
        
      }).catch(function (error) {
        setShowProcessing(false)
        errorhandler(error)
      }) 
      
      
    } 


    const showVehicle = () => {
        return (
              <Table style={{fontSize : "0.8rem"}}>
                <thead>
                    <tr>
                  <th></th>
                  <th>Feature</th>
                  <th style={{textAlign : "center"}}>Value</th>
                  {/** <th style={{textAlign : "center"}}>Max</th> */}
                  </tr>
                </thead>
                <tbody>
                  {
                     vehicle.features.map((x , key) => {
                      if(x.featureCode !== ""){
                        return (
                          <tr key={key}>
                            <td><img alt="..." width={"30px"} src={`${x.ficon}`} style={{ cursor : "pointer"}} /> </td>
                            <td>{x.en}</td>
                            <td style={{textAlign : "center"}}>{x.rangevalueL}</td>
                         {/**   <td style={{textAlign : "center"}}>{x.rangevalueH}</td>*/} 
                        
                          </tr>
                        )  
                      }
                      })
                  }
                 
                </tbody>
              </Table>
         
        )
      }

    const showfeaturestable = () => {
 
      try{
       
          return (
            <VfeatureTab showft={showft} setShowft={setShowft} features={features} featuresList={featuresList} setFeatureslist={setFeatureslist} vehicle = {vehicle} setVehicle={setVehicle}/>
          )
     
      }catch(e){
        console.log(e)
      }
     
    }

 //const showmc = vehicle.imgmc.includes("tuid") ? `${process.env.REACT_APP_APIURL}/limg/${props.user.tuid}/listing/${vehicle.imgmc}` : srcmc

    
    const showmc = () => {
      try{
        if(vehicle.imgmc.includes("tuid")){
          return `${vehicle.imgmc}`
        }else{
        
          return srcmc
        }
      }catch(e){
         return srcmc
      }
    }
  
    const showpc0 = () => {
      try{
        if(vehicle.imgpc[0].includes("tuid")){
          return `${vehicle.imgpc[0]}`
        }else{
          return srcpc1
        }
      }catch(e){
        return srcpc1
      }
    }

    const showpc1 = () => {
      try{
      
        if(vehicle.imgpc[1].includes("tuid")){
          return `${vehicle.imgpc[1]}`
        }else{
          return srcpc2
        }
      }catch(e){
        return srcpc2
      }
    }
    const showpc2 = () => {
      try{
        
        if(vehicle.imgpc[2].includes("tuid")){
          return `${vehicle.imgpc[2]}`
        }else{
          return srcpc3
        }
      }catch(e){
       return srcpc3
      }
    }
    const showpc3 = () => {
      try{
        
        if(vehicle.imgpc[3].includes("tuid")){
          return `${vehicle.imgpc[3]}`
          // return `${process.env.REACT_APP_APIURL}/limg/${props.user.tuid}/listing/${vehicle.imgpc[3]}`
        }else{
          return srcpc4
        }
      }catch(e){
        return srcpc4
      }
    }

    const handleClickM = event => {
      hiddenFileInputM.current.click();
    };
  
    const handleImgM = (e) => {
      
      if(e.target.files[0]) {
              
          if(filenamevalid(e.target.files[0])){
            setFilenamesmc(e.target.files[0])
            setImgmc({
              srcmc: URL.createObjectURL(e.target.files[0]),
              altmc: e.target.files[0].name
          });
          setVehicle({...vehicle, imgmc : e.target.files[0].name})
          }else{
            handleCompressedUpload(e.target.files[0], "main")

            setImgmc({
              srcmc: URL.createObjectURL(e.target.files[0]),
              altmc: e.target.files[0].name
          });
          setVehicle({...vehicle, imgmc : e.target.files[0].name})
          // let nf = handleCompressedUpload(e.target.files[0])
           
          }
          
      
      }   
  }

  const handleClick1 = event => {
        hiddenFileInput1.current.click();
      };

  const handleImg1 = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalidom(e.target.files[0])){
              setFilenamespc1(e.target.files[0])
              setImgpc1({
                srcpc1: URL.createObjectURL(e.target.files[0]),
                altpc1: e.target.files[0].name
            });
            setVehicle({...vehicle, imgpc : [e.target.files[0].name, vehicle.imgpc[1], vehicle.imgpc[2], vehicle.imgpc[3]]})
            }else{
              handleCompressedUpload(e.target.files[0], "first")

              setImgpc1({
                srcpc1: URL.createObjectURL(e.target.files[0]),
                altpc1: e.target.files[0].name
            });
            setVehicle({...vehicle, imgpc : [e.target.files[0].name, vehicle.imgpc[1], vehicle.imgpc[2], vehicle.imgpc[3]]})
            // let nf = handleCompressedUpload(e.target.files[0])
             
            }
            
        
        }   
       }

  const handleClick2 = event => {
        hiddenFileInput2.current.click();
      };

  const handleImg2 = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalidom(e.target.files[0])){
              setFilenamespc2(e.target.files[0])
              setImgpc2({
                srcpc2: URL.createObjectURL(e.target.files[0]),
                altpc2: e.target.files[0].name
            });
            setVehicle({...vehicle, imgpc : [vehicle.imgpc[0], e.target.files[0].name,  vehicle.imgpc[2], vehicle.imgpc[3]]})
            }else{
              handleCompressedUpload(e.target.files[0], "second")

              setImgpc2({
                srcpc2: URL.createObjectURL(e.target.files[0]),
                altpc2: e.target.files[0].name
              });
              setVehicle({...vehicle, imgpc : [vehicle.imgpc[0], e.target.files[0].name,  vehicle.imgpc[2], vehicle.imgpc[3]]})
            }
            
        
        }   
      }

  const handleClick3 = event => {
        hiddenFileInput3.current.click();
      };

  const handleImg3 = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalidom(e.target.files[0])){
              setFilenamespc3(e.target.files[0])
              setImgpc3({
                srcpc3: URL.createObjectURL(e.target.files[0]),
                altpc3: e.target.files[0].name
            });
            setVehicle({...vehicle, imgpc : [vehicle.imgpc[0],   vehicle.imgpc[1],  e.target.files[0].name,vehicle.imgpc[3]]})
          
            }else{
              handleCompressedUpload(e.target.files[0], "third")
              setImgpc3({
                srcpc3: URL.createObjectURL(e.target.files[0]),
                altpc3: e.target.files[0].name
              });
              setVehicle({...vehicle, imgpc : [vehicle.imgpc[0], vehicle.imgpc[1] , e.target.files[0].name, vehicle.imgpc[3]]})
            }
        }   
      }

  const handleClick4 = event => {
        hiddenFileInput4.current.click();
      };

  const handleImg4 = (e) => {
        
        if(e.target.files[0]) {
                
            if(filenamevalidom(e.target.files[0])){
              setFilenamespc4(e.target.files[0])
              setImgpc4({
                srcpc4: URL.createObjectURL(e.target.files[0]),
                altpc4: e.target.files[0].name
            });
            setVehicle({...vehicle, imgpc : [vehicle.imgpc[0],   vehicle.imgpc[1],  vehicle.imgpc[2], e.target.files[0].name,]})
            }else{
              handleCompressedUpload(e.target.files[0], "fourth")
              setImgpc4({
                srcpc4: URL.createObjectURL(e.target.files[0]),
                altpc4: e.target.files[0].name
              });
              setVehicle({...vehicle, imgpc : [vehicle.imgpc[0], vehicle.imgpc[1] , vehicle.imgpc[2] , e.target.files[0].name]})
            }
            
        
        }   
      }
//vehicle.approxmiles, vehicle.bid, vehicle.blogo , vehicle.bname.en, vehicle.category.en,
// vehicle.categoryCode, vehicle.daily.amt, vehicle.daily.mileq, vehicle.daily.wdamt, vehicle.daily.xmileq,
//vehicle.extcolor, vehicle.features.length, vehicle.intcolor, vehicle.mname.en, vehicle.modelyear, vehicle.notes, vehicle.vid,vehicle.vtypeCode, vehicle.vtname.en  
      
    const copyform = () => {
      setShowProcessing(true)
      props.API({
        method: "post",
        url : `ten/copylisting`,
        data: {tluid : vehicle.tluid, tuid : vehicle.tuid},
        headers : {"arixauth" : localStorage.getItem("arixauth")}
        }).then((res) => {
         props.swal("Listing Updated")
         setShowProcessing(false)
        }).then(f => {
          setShowProcessing(false)
          mylisting()
        })
        .catch(function (error) {
          
          setShowProcessing(false)
          errorhandler(error)
    })
    }  

    const submitform = () => {
      

    if( mylist.length >=  props.user.ala){
      props.swal("Unauthorized, acceding limit to total allowed.")
      
    }else{
      setShowProcessing(true)
      if(vehicle.categoryCode === "1" && fieldvalidator(vehicle.approxmiles,  vehicle.modelyear.label, vehicle.vtname.en, vehicle.features.length, vehicle.intcolor,vehicle.extcolor,
        vehicle.daily.amt, vehicle.daily.mileq, vehicle.daily.xmileq)){
       props.swal("Vehicle Required Fields are EMPTY!")
       setShowProcessing(false)
      }else if(vehicle.categoryCode !== "1" && fieldvalidator( vehicle.modelyear.label, vehicle.vtname.en, vehicle.features.length, vehicle.intcolor,
        vehicle.hourly.amt, vehicle.hourly.wdamt))
      {
        props.swal("Vehicle Required Fields for machine or yachts are EMPTY!")
        setShowProcessing(false)
      }
      else{
        if(vupdateMode){
          let formData = new FormData(); 
          filenamesmc !== undefined ?  formData.append("imgmc" , filenamesmc, vehicle.imgmc) : formData.append("imgmc" , filenamesmc )
          filenamespc1 !== undefined ?  formData.append("imgpc1" , filenamespc1, vehicle.imgpc[0]) :  formData.append("imgpc1" , filenamespc1)
          filenamespc2 !== undefined ? formData.append("imgpc2" , filenamespc2, vehicle.imgpc[1]) :  formData.append("imgpc2" , filenamespc2)
          filenamespc3 !== undefined ? formData.append("imgpc3" , filenamespc3, vehicle.imgpc[2] ) :  formData.append("imgpc3" , filenamespc3)
          filenamespc4 !== undefined ? formData.append("imgpc4" , filenamespc4, vehicle.imgpc[3] ) : formData.append("imgpc4" , filenamespc4)
          
          formData.append("vehicle" , JSON.stringify(vehicle))
          formData.append("tuid", props.user.tuid)
// first check the counter .. 
          props.API.get(`tenant/lucc` , {headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            console.log(res.data.message)
            if(res.data.message){
              console.log(res.data.message)
              props.API({
                method: "post",
                url : `ten/updatelisting`,
                data: formData,
                headers : {"arixauth" : localStorage.getItem("arixauth") ,  "Content-Type": "multipart/form-data"}
                }).then((res) => {
                 props.swal(`Listing Updated`)
                 setShowProcessing(false)
                }).then(f => {
                  mylisting()
                })
                .catch(function (error) {
                  console.log(error)
                  setShowProcessing(false)
                 errorhandler(error)
            })
            }else{
              props.swal(`Listing update limit exceeded, please check listing page.`)
              setShowProcessing(false)
            }
            
            
          }).catch(y => {
            console.log(y)
            setShowProcessing(false)
          })
{/** 
          props.API({
            method: "post",
            url : `ten/updatelisting`,
            data: formData,
            headers : {"arixauth" : localStorage.getItem("arixauth") ,  "Content-Type": "multipart/form-data"}
            }).then((res) => {
             props.swal(`Listing Updated, You have updated ${res.data.tdu} / ${res.data.allowed} times for the day.`)
             setShowProcessing(false)
            }).then(f => {
              mylisting()
            })
            .catch(function (error) {
              console.log(error)
              setShowProcessing(false)
             errorhandler(error)
        })
*/}

        }else {
          let formData = new FormData(); 
          filenamesmc !== undefined ?  formData.append("imgmc" , filenamesmc, vehicle.imgmc) : formData.append("imgmc" , filenamesmc )
          filenamespc1 !== undefined ?  formData.append("imgpc1" , filenamespc1, vehicle.imgpc[0]) :  formData.append("imgpc1" , filenamespc1)
          filenamespc2 !== undefined ? formData.append("imgpc2" , filenamespc2, vehicle.imgpc[1]) :  formData.append("imgpc2" , filenamespc2)
          filenamespc3 !== undefined ? formData.append("imgpc3" , filenamespc3, vehicle.imgpc[2] ) :  formData.append("imgpc3" , filenamespc3)
          filenamespc4 !== undefined ? formData.append("imgpc4" , filenamespc4, vehicle.imgpc[3] ) : formData.append("imgpc4" , filenamespc4)
         
          formData.append("vehicle" , JSON.stringify(vehicle))
          formData.append("tuid", props.user.tuid)
          props.API({
            method: "post",
            url : `tenant/createListings3`,
            data: formData,
            headers : {"arixauth" : localStorage.getItem("arixauth") ,  "Content-Type": "multipart/form-data"}
            }).then((res) => {
              setShowProcessing(false)
              props.swal(res.data.message).then(c => window.location.reload(false))
              
            }).then(x => {
              mylisting()
            }).catch(function (error) {
              setShowProcessing(false)
              errorhandler(error)
        })
        }
         
      }

    }
   
    return 

     }


    const showtluid = () => {
      try{
        return (
          <span style={{float : "right"}}>Selected : <h6 style={{color : "blue", float : "right"}}>{vehicle.tluid}</h6></span>
        )
      }catch(e){

      }
    }

 // this will be used to show vehicle entry.    
    const vehiclecard = () =>{ 
      
        return (
          <Card>
          <CardBody>
             <Row>
                     <Col sm="12" md="4">
                     <FormGroup>
                         <label> Catagory </label>
                         <Input type="text" readOnly value={vehicle.category.en} />  
                     </FormGroup>
                     </Col>
                     <Col sm="12" md="4">
                       <FormGroup>
                         <label> Brand </label>
                         <Input type="text" readOnly value={vehicle.bname.en} /> 
                         </FormGroup> 
                     </Col>
                     <Col md="4">
                     <FormGroup>
                         <label>Specification</label>
                         <Input
                         
                         value={vehicle.notes}
                         placeholder="en"
                         type="text"
                         readOnly
                         />
                     </FormGroup>
                   </Col>
             </Row>
             <Row style={{marginTop  :5}}>
                <Col><h6>Model Details</h6></Col>
             </Row>      
             <Row style={{marginTop  :5}}>
                     <Col md="3">
                     <FormGroup>
                         <label>Name EN</label>
                         <Input
                          value={vehicle.mname.en}
                         type="text"
                         readOnly  
                         />
                   </FormGroup>
                     </Col>
                    
                     <Col md="3">
                     <FormGroup>
                         <label>اسم</label>
                         <Input
                          value={vehicle.mname.ar}
                          type="text"
                          readOnly  
                         />
                     </FormGroup>
                     </Col>
                     <Col md="3">
                  
                  </Col>
                     <Col md="3">
                   <FormGroup>
                      <label>Year</label>
                      <Select options={modelyears} styles={customStyles} 
                                     onChange={e=> {
                                       setVehicle({...vehicle, modelyear : e})
                                      }} value={vehicle.modelyear}
                                     />
                     </FormGroup>
                  </Col>
             </Row>     
          
           <Row style={{marginTop  :5}}>
             <Col sm = "3">
               <FormGroup>
                  <label>Type</label>
                          <Select options={vtypeList.filter(g => g.categoryCode === vehicle.categoryCode).map(f => {
                                               return {
                                                 ...f, value : f.typeCode, label : f.typeName.en
                                               }
                                             })} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, vtypeCode : e.value , vtname : e.typeName })
                              }}
                           value={{label : vehicle.vtname.en , value : vehicle.vtypeCode}}
                            />
                  </FormGroup>
             </Col>
             <Col sm = "3">
               <FormGroup>
                  <label>Body</label>
                          <Select options={btypeList.filter(g => g.categoryCode === vehicle.categoryCode).map(f => {
                                               return {
                                                 ...f, value : f.typeCode, label : f.typeName.en
                                               }
                                             })} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, btypeCode : e.value , btname : e.typeName })
                              }}
                           value={{label : vehicle?.btname?.en , value : vehicle?.btypeCode}}
                            />
                  </FormGroup>
             </Col>
             <Col sm = "3">
             <FormGroup style={{textAlign : "center"}}>
                  <label>Features</label>
                          <br /><label><i className="fa fa-external-link fa-3x" aria-hidden="true" onClick={g => {setShowft(true);}}></i></label>
                  </FormGroup>
             </Col>
             <Col sm = "3">
             <FormGroup style={{textAlign : "center"}}>
                  <label>Pictures</label>
                          <br /><label><i className="fa fa-external-link fa-3x fa-rotate-180" aria-hidden="true" onClick={g => setClp(!clp)}></i></label>
                  </FormGroup>
             </Col>
         </Row>
         <hr/>
         <Collapse isOpen={clp}>
         <p style={{textAlign : "center"}}>*For best results use 1096 x 864, max 500kb size, **do not use same image in single update</p>
         <Row> {/**image aspact ratio is 1.24 */}
                <Col md="5"><img src={showmc()} alt="mainpic" width="400px"  onClick={e => {handleClickM(e)}}/></Col>           
                <Col md="7">
                      <Row><Col><img src={showpc0()} alt="mainpc1" onClick={e => {handleClick1(e)}} /></Col> <Col><img src={showpc1()} alt="mainpc1"  onClick={e => {handleClick2(e)}} /></Col></Row>    
                      <Row><Col><img src={showpc2()} alt="mainpc2"  onClick={e => {handleClick3(e)}} /></Col><Col><img src={showpc3()} alt="mainpc1"  onClick={e => {handleClick4(e)}}/></Col></Row> 
                 </Col>           
         </Row>
       
         <hr />
         </Collapse>
         <Row style={{marginTop  :5}}>
             <Col>
             {showVehicle()}
             </Col>
         </Row>
         <hr />
         <Row style={{marginTop  : 10}}>
           <Col sm ="12" md="6">
             <Row>
             <Col md="6"><span style={{float :"left" ,paddingTop : 10}}>Transmission</span></Col><Col md="6">
             <Select options={[{value : 0, label : "Auto" , fr : "Auto", ar : "آلي"}, {value : 1, label : "Manual", fr : "Manuel", ar : "يدوي"}, {value : 2, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, trmname : {en : e.label, fr : e.fr , ar : e.ar} , trmcode : e.value })
                              }}
                           value={{label : vehicle.trmname.en , value : vehicle.trmcode}}
                            />
             </Col>
             </Row>
           </Col>
           <Col sm ="12" md="6">
             <Row>
               <Col md="6"><span style={{float : "right", paddingTop : 10}}>Fuel</span></Col><Col md="6">
               <Select options={[{value : 0, label : "Petrol" , fr : "Essence", ar : "بنزين"}, {value : 2, label : "Diesel", fr : "Diesel", ar : "ديزل"}, {value : 3, label : "Electric", fr : "Électrique" , ar : "هجكهربائين"},{value : 4, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, fuelname : {en : e.label, fr : e.fr , ar : e.ar} , fuelcode : e.value })
                              }}
                           value={{label : vehicle.fuelname.en , value : vehicle.fuelcode}}
                            />
               </Col>
             </Row>
             
           </Col>
         </Row>
         <hr />
         <Row>
           <Col sm ="12" md="6">
          
               <Row>
               <Col md="6">Full / Thirdparty Insurence</Col>
               <Col md="6">
                <Switch
                   offColor="primary"
                   offText="Thrd"
                   onColor="primary"
                   onText="Full"
                   onChange = {x => setVehicle({...vehicle, insurence : !vehicle.insurence})}
                   value={vehicle.insurence}
                 /></Col>
               </Row>
            </Col>
      
           <Col sm ="12" md="6">
             <Row>
             <Col md="6">Approx K.M</Col><Col md="6"><Input maxLength={6} style={{marginTop : -5}} type="text" 
              value={vehicle.approxmiles} 
              onChange={g => {
                     setVehicle({...vehicle , approxmiles : numtests.test(g.target.value) ? g.target.value : "0"})
             }} /></Col>
          
             </Row>
             
           </Col>
         </Row>
         
         <Row style={{marginTop  : 10}}>
           <Col sm ="12" md="6">
             <Row>
             <Col md="6">Interior Color</Col><Col md="6"><Input maxLength={20} style={{marginTop : -5}} type="text" value={vehicle.intcolor} onChange={g => {
                      setVehicle({...vehicle , intcolor : alphaspace.test(g.target.value) ? g.target.value : ""})
                 }} /></Col>
             </Row>
           </Col>
           <Col sm ="12" md="6">
             <Row>
               <Col md="6">Exterior Color</Col><Col md="6"><Input  maxLength={20} style={{marginTop : -5}} type="text" value={vehicle.extcolor} onChange={g => {
                     setVehicle({...vehicle , extcolor : alphaspace.test(g.target.value) ? g.target.value : ""})
              }} /></Col>
             </Row>
             
           </Col>
         </Row>
         <hr />
         <Row>
           <Col>
           <ul>
             <li>
             With <span style={{color : "red"}}>*</span> are prices for registered users. 
             </li>
             <li>
             Additional Quota Amount is Amount / Kilometer if exceed in any case multiplied by number of times
             </li>
           </ul>
              
                        <Table >
                             <thead >
                                 <tr>
                                     <th style={{fontSize : "0.6em"}}>Price For</th>
                                     <th style={{fontSize : "0.6em"}}>Amount</th>
                                     <th style={{fontSize : "0.6em"}}>With Driver Amount</th>
                                     <th style={{fontSize : "0.6em"}}>K.M Quota</th>
                                     <th style={{fontSize : "0.6em"}}>Additional Charges/ KM</th>
                                 </tr>
                             </thead>
                             <tbody>
                                 <tr>
                                     <td>Daily</td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.daily.amt} onChange={g => {
                                          setVehicle({...vehicle , daily : {...vehicle.daily, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                      <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.daily.wdamt} onChange={g => {
                                           setVehicle({...vehicle , daily : {...vehicle.daily, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                          }} /></td>
                                     <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.daily.mileq} onChange={g => {
                                          setVehicle({...vehicle , daily : {...vehicle.daily, mileq :numtests.test(g.target.value) ? g.target.value : "0"}})
                                      }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.daily.xmileq} onChange={g => {
                                           setVehicle({...vehicle , daily : {...vehicle.daily, xmileq : floattest.test(g.target.value) ? g.target.value : "0"}})
                                      }} /></td>
                                 </tr>
                              {/** 
                                 <tr>
                                     <td>Daily <span style={{color : "red"}}>*</span></td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fdaily.amt} onChange={g => {
                                            setVehicle({...vehicle , fdaily : {...vehicle.fdaily, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                         }} /></td>
                                      <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fdaily.wdamt} onChange={g => {
                                           setVehicle({...vehicle , fdaily : {...vehicle.fdaily, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                          }} /></td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fdaily.mileq} onChange={g => {
                                           setVehicle({...vehicle , fdaily : {...vehicle.fdaily, mileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fdaily.xmileq} onChange={g => {
                                           setVehicle({...vehicle , fdaily : {...vehicle.fdaily, xmileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                         }} /></td>
                                 </tr>
                                 */}
                                
                                 <tr>
                                     <td>Weekly</td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.weekly.amt} onChange={g => {
                                           setVehicle({...vehicle , weekly : {...vehicle.weekly, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                      <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.weekly.wdamt} onChange={g => {
                                          setVehicle({...vehicle , weekly : {...vehicle.weekly, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                         }} /></td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.weekly.mileq} onChange={g => {
                                           setVehicle({...vehicle , weekly : {...vehicle.weekly, mileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                         }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.weekly.xmileq} onChange={g => {
                                          setVehicle({...vehicle , weekly : {...vehicle.weekly, xmileq :  floattest.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                 </tr>
                                 {/** 
                                 <tr>
                                     <td>Weekly <span style={{color : "red"}}>*</span></td>
                                     <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.fweekly.amt} onChange={g => {
                                           setVehicle({...vehicle , fweekly : {...vehicle.fweekly, amt :  numtests.test(g.target.value) ? g.target.value : "0"}})
                                    }} /></td>
                                      <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.fweekly.wdamt} onChange={g => {
                                           setVehicle({...vehicle , fweekly : {...vehicle.fweekly, wdamt :  numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                   <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.fweekly.mileq} onChange={g => {
                                           setVehicle({...vehicle , fweekly : {...vehicle.fweekly, mileq :  numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fweekly.xmileq} onChange={g => {
                                           setVehicle({...vehicle , fweekly : {...vehicle.fweekly, xmileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                 </tr>
                               */}
                                 <tr>
                                     <td>Monthly</td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.amt} onChange={g => {
                                          setVehicle({...vehicle , monthly : {...vehicle.monthly, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                      <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.wdamt} onChange={g => {
                                           setVehicle({...vehicle , monthly : {...vehicle.monthly, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                       }} /></td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.mileq} onChange={g => {
                                           setVehicle({...vehicle , monthly : {...vehicle.monthly, mileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.xmileq} onChange={g => {
                                           setVehicle({...vehicle , monthly : {...vehicle.monthly, xmileq : floattest.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                 </tr>
                                {/** 
                                 <tr>
                                     <td>Monthly <span style={{color : "red"}}>*</span></td>
                                     <td><Input style={{marginTop : -5}} type="text"maxLength={6} value={vehicle.fmonthly.amt} onChange={g => {
                                           setVehicle({...vehicle , fmonthly : {...vehicle.fmonthly, amt :  numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                      <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.fmonthly.wdamt} onChange={g => {
                                           setVehicle({...vehicle , fmonthly : {...vehicle.fmonthly, wdamt :  numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.fmonthly.mileq} onChange={g => {
                                         setVehicle({...vehicle , fmonthly : {...vehicle.fmonthly, mileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                    
                                    <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.fmonthly.xmileq} onChange={g => {
                                           setVehicle({...vehicle , fmonthly : {...vehicle.fmonthly, xmileq : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                 </tr>
                                */}
                             </tbody>
                         </Table>        
                     </Col>
         </Row>
          <hr />
          <Row>
           <Col>
            <label>Additional Info</label>
            <Input type="textarea" maxLength={256} placeholder="About this Listing" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, en : x.target.value}})}
            value={vehicle.additionalinfo.en}/>

           </Col>
          {/** <Col>
            <label>Additional Info (fr)</label>
            <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, fr : x.target.value}})}
            value={vehicle.additionalinfo.fr}/>

           </Col>  */}
           <Col>
            <label>Additional Info (Ar)</label>
            <Input type="textarea" maxLength={256} placeholder="حول هذه القائمة" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, ar : x.target.value}})}
            value={vehicle.additionalinfo.ar}/>

           </Col>
          </Row>
          <Row style={{marginTop : 15}}>
           <Col>
            <label>Documents Required for Resident (en / ar), use comma as seperator.</label>
            <Row>
             <Col>   <Input type="textarea" maxLength={256} placeholder="Comma Seperated list" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, en : x.target.value}})}
            value={vehicle.documentsrequiredresident.en}/></Col>
             {/** 
             <Col>
             <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, fr : x.target.value}})}
            value={vehicle.documentsrequiredresident.fr}/>
            </Col>*/}
             <Col>
             <Input type="textarea" maxLength={256} placeholder="قائمة مفصولة بفواصل" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, ar : x.target.value}})}
            value={vehicle.documentsrequiredresident.ar}/>
            </Col>
            </Row>
           

           </Col>
           </Row>
           <Row style={{marginTop : 15}}>
           <Col>
            <label>Documents Required for Non Resident (en / ar) , use comma as seperator.</label>
            <Row>
             <Col>   <Input type="textarea" maxLength={256} placeholder="Required Documents for non resident" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, en : x.target.value}})}
            value={vehicle.documentsrequiredtourist.en}/></Col>
             {/**<Col>
             <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, fr : x.target.value}})}
            value={vehicle.documentsrequiredtourist.fr}/>
            </Col>*/}
             <Col>
             <Input type="textarea" maxLength={256} placeholder="المستندات المطلوبة لغير المقيمين" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, ar : x.target.value}})}
            value={vehicle.documentsrequiredtourist.ar}/>
            </Col>
            </Row>
           

           </Col>
           </Row>
           <Row style={{marginTop  : 15}}>
             <Col><label>Salik / Toll Charges</label><Input type="text"  maxLength={4} placeholder="" 
            onChange = {x => setVehicle({...vehicle, saliktollcharges:  floattest.test(x.target.value) ? x.target.value : "0"})}
            value={vehicle.saliktollcharges}/> </Col>
             <Col>
             <label>security deposit</label><Input maxLength={10} type="text" placeholder="" 
            onChange = {x => setVehicle({...vehicle, securitydeposit :   numtests.test(x.target.value) ? x.target.value : "0" })}
            value={vehicle.securitydeposit}/>
             </Col>
           </Row>
           <Row style={{marginTop  : 15}}>
             <Col><label>Deposit Return Days</label><Input maxLength={3} type="text" placeholder="" 
            onChange = {x => setVehicle({...vehicle, refunddays : numtests.test(x.target.value) ? x.target.value : "0" })}
            value={vehicle.refunddays}/> </Col>
             <Col>
             <label>Min Driver Age</label><Input type="text" maxLength={2} placeholder="" 
            onChange = {x => setVehicle({...vehicle, mindriverage : numtests.test(x.target.value) ? x.target.value : "18" })}
            value={vehicle.mindriverage}/>
             </Col>
           </Row>
          </CardBody>
          <CardFooter>
           <center><Button color={vupdateMode ? "warning" : "primary" } onClick={c => submitform()}>{vupdateMode ? "Update" : "Create" }</Button>
           <br />{vupdateMode && <Button color={"info"} style={{marginTop : 5}} onClick={c => copyform("x")}>Copy to New</Button>}
           </center>
           
          </CardFooter>
         </Card>    

        )
    }

     // this will be used to show vehicle entry.    
     const othercard = () =>{ 
      
        return (
          <Card>
          <CardBody>
             <Row>
                     <Col sm="12" md="4">
                     <FormGroup>
                         <label> Catagory </label>
                         <Input type="text" readOnly value={vehicle.category.en} />  
                     </FormGroup>
                     </Col>
                     <Col sm="12" md="4">
                       <FormGroup>
                         <label> Brand </label>
                         <Input type="text" readOnly value={vehicle.bname.en} /> 
                         </FormGroup> 
                     </Col>
                     <Col md="4">
                     <FormGroup>
                         <label>Specification</label>
                         <Input
                         maxLength={10}
                         value={vehicle.notes}
                         placeholder="en"
                         type="text"
                         onChange={h => setVehicle({...vehicle, notes : h.target.value})}
                         />
                     </FormGroup>
                   </Col>
             </Row>
             <Row style={{marginTop  :10, marginBottom : 5}}>
                <Col><u><b>Details </b></u> </Col>
             </Row>      
             <Row style={{marginTop  :5}}>
                     <Col md="3">
                     <FormGroup>
                         <label>Name EN</label>
                         <Input
                          value={vehicle.mname.en}
                         type="text"
                         readOnly  
                         />
                   </FormGroup>
                     </Col>
                    
                     <Col md="3">
                     <FormGroup>
                         <label>اسم</label>
                         <Input
                          value={vehicle.mname.ar}
                          type="text"
                          readOnly  
                         />
                     </FormGroup>
                     </Col>
                     <Col md="3">
                  
                  </Col>
                     <Col md="3">
                   <FormGroup>
                      <label>Year</label>
                      <Select options={modelyears} styles={customStyles} 
                                     onChange={e=> {
                                       setVehicle({...vehicle, modelyear : e})
                                      }} value={vehicle.modelyear}
                                     />
                     </FormGroup>
                  </Col>
             </Row>     
          
           <Row style={{marginTop  :5}}>
             <Col sm = "6">
               <FormGroup>
                  <label>Type</label>
                          <Select options={vtypeList.filter(g => g.categoryCode === vehicle.categoryCode).map(f => {
                                               return {
                                                 ...f, value : f.typeCode, label : f.typeName.en
                                               }
                                             })} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, vtypeCode : e.value , vtname : e.typeName })
                              }}
                           value={{label : vehicle.vtname.en , value : vehicle.vtypeCode}}
                            />
                  </FormGroup>
             </Col>
             <Col sm = "3">
             <FormGroup style={{textAlign : "center"}}>
                  <label>Features</label>
                          <br /><label><i className="fa fa-external-link fa-3x" aria-hidden="true" onClick={g => {setShowft(true);}}></i></label>
                  </FormGroup>
             </Col>
             <Col sm = "3">
             <FormGroup style={{textAlign : "center"}}>
                  <label>Pictures</label>
                          <br /><label><i className="fa fa-external-link fa-3x fa-rotate-180" aria-hidden="true" onClick={g => setClp(!clp)}></i></label>
                  </FormGroup>
             </Col>
         </Row>
         <hr/>
         <Collapse isOpen={clp}>
         <p style={{textAlign : "center"}}>*For best results use 1096 x 864, max 500kb size, **do not use same image in single update</p>
         <Row> {/**image aspact ratio is 1.24 */}
                <Col md="5"><img src={showmc()} alt="mainpic" width="400px"  onClick={e => {handleClickM(e)}}/></Col>           
                <Col md="7">
                      <Row><Col><img src={showpc0()} alt="mainpc1" onClick={e => {handleClick1(e)}} /></Col> <Col><img src={showpc1()} alt="mainpc1"  onClick={e => {handleClick2(e)}} /></Col></Row>    
                      <Row><Col><img src={showpc2()} alt="mainpc2"  onClick={e => {handleClick3(e)}} /></Col><Col><img src={showpc3()} alt="mainpc1"  onClick={e => {handleClick4(e)}}/></Col></Row> 
                 </Col>           
         </Row>
       
         <hr />
         </Collapse>
         <Row style={{marginTop  :5}}>
             <Col>
             {showVehicle()}
             </Col>
         </Row>
         <hr />
         <Row>
           <Col sm ="12" md="6">
          
               <Row>
               <Col md="6">Full / Thirdparty Insurence</Col>
               <Col md="6">
                <Switch
                   offColor="primary"
                   offText="Thrd"
                   onColor="primary"
                   onText="Full"
                   onChange = {x => setVehicle({...vehicle, insurence : !vehicle.insurence})}
                   value={vehicle.insurence}
                 /></Col>
               </Row>
            </Col>
      
           <Col sm ="12" md="6">
             <Row>
             <Col md="6"><span style={{float : "right", paddingTop : 10}}>Fuel</span></Col><Col md="6">
               <Select options={[{value : 0, label : "Petrol" , fr : "Essence", ar : "بنزين"}, {value : 2, label : "Diesel", fr : "Diesel", ar : "ديزل"}, {value : 3, label : "Electric", fr : "Électrique" , ar : "هجكهربائين"},{value : 4, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                            onChange={e=> {
                                setVehicle({...vehicle, fuelname : {en : e.label, fr : e.fr , ar : e.ar} , fuelcode : e.value })
                              }}
                           value={{label : vehicle.fuelname.en , value : vehicle.fuelcode}}
                            />
               </Col>
                
             </Row>
             
           </Col>
         </Row>
         
         <Row style={{marginTop  : 10}}>
           <Col sm ="12" md="6">
             <Row>
             <Col md="6">Color</Col><Col md="6"><Input maxLength={20} style={{marginTop : -5}} type="text" value={vehicle.intcolor} onChange={g => {
                      setVehicle({...vehicle , intcolor : alphaspace.test(g.target.value) ? g.target.value : "", extcolor : alphaspace.test(g.target.value) ? g.target.value : ""})
                 }} /></Col>
             </Row>
           </Col>
           <Col sm ="12" md="6">
                <span style={{float : "right", marginTop  : 5}}>Update actual pictures for color details</span>             
           </Col>
         </Row>
         <hr />
         <Row>
           <Col>
           <ul>
             <li>
             With <span style={{color : "red"}}>*</span> are prices for registered users. 
             </li>
             <li>
             Additional Quota Amount is Amount / Kilometer if exceed in any case multiplied by number of times
             </li>
           </ul>
              
                        <Table >
                             <thead >
                                 <tr>
                                     <th style={{fontSize : "0.6em"}}>Price For</th>
                                     <th style={{fontSize : "0.6em"}}>Amount</th>
                                     <th style={{fontSize : "0.6em"}}>Amt with Operators</th>
                                     <th style={{fontSize : "0.6em"}}></th>
                                     <th style={{fontSize : "0.6em"}}></th>
                                 </tr>
                             </thead>
                             <tbody>
                                 <tr>
                                     <td>Hourly</td>
                                     <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.hourly.amt} onChange={g => {
                                          setVehicle({...vehicle , hourly : {...vehicle.hourly, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                      <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.hourly.wdamt} onChange={g => {
                                           setVehicle({...vehicle , hourly : {...vehicle.hourly, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                          }} /></td>
                                     
                                 </tr>
                              
                             </tbody>
                         </Table>        
                     </Col>
         </Row>
          <hr />
          <Row>
           <Col>
            <label>Additional Info</label>
            <Input type="textarea" maxLength={256} placeholder="About this Listing" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, en : x.target.value}})}
            value={vehicle.additionalinfo.en}/>

           </Col>
          {/** <Col>
            <label>Additional Info (fr)</label>
            <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, fr : x.target.value}})}
            value={vehicle.additionalinfo.fr}/>

           </Col>  */}
           <Col>
            <label>Additional Info (Ar)</label>
            <Input type="textarea" maxLength={256} placeholder="حول هذه القائمة" 
            onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, ar : x.target.value}})}
            value={vehicle.additionalinfo.ar}/>

           </Col>
          </Row>
          <Row style={{marginTop : 15}}>
           <Col>
            <label>Documents Required.</label>
            <Row>
             <Col>   <Input type="textarea" maxLength={256} placeholder="Comma Seperated list" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, en : x.target.value}, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, en : "-"}})}
            value={vehicle.documentsrequiredresident.en}/></Col>
             {/** 
             <Col>
             <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, fr : x.target.value}})}
            value={vehicle.documentsrequiredresident.fr}/>
            </Col>*/}
             <Col>
             <Input type="textarea" maxLength={256} placeholder="قائمة مفصولة بفواصل" 
            onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, ar : x.target.value}, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, ar : "-"}})}
            value={vehicle.documentsrequiredresident.ar}/>
            </Col>
            </Row>
           

           </Col>
           </Row>
           
           <Row style={{marginTop  : 15}}>
             <Col>
             <label>security deposit</label><Input maxLength={10} type="text" placeholder="" 
            onChange = {x => setVehicle({...vehicle, securitydeposit :   numtests.test(x.target.value) ? x.target.value : "" })}
            value={vehicle.securitydeposit}/>
             </Col>
             <Col><label>Return Days</label><Input maxLength={3} type="text" placeholder="" 
              onChange = {x => setVehicle({...vehicle, refunddays : numtests.test(x.target.value) ? x.target.value : "" })}
              value={vehicle.refunddays}/> </Col>
           </Row>
           {vehicle?.categoryCode === "2" && 
             <> <Row style={{marginTop  : 15}}>
                  <Col>
                  <label>Certifications</label><Input maxLength={100} type="text" placeholder="" 
                onChange = {x => setVehicle({...vehicle, mcertifications :   x.target.value })}
                value={vehicle?.mcertifications}/>
                  </Col>
                  <Col><label>Mobilization Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => {setVehicle({...vehicle, mobilizationCharges : x.target.value }); console.log(x)}}
                  value={vehicle?.mobilizationCharges}/> </Col>
            </Row>
            <Row style={{marginTop  : 15}}>
                  <Col>
                  <label>Food Charges</label><Input maxLength={100} type="text" placeholder="" 
                onChange = {x => setVehicle({...vehicle, mfoodcharges :  x.target.value })}
                value={vehicle?.mfoodcharges}/>
                  </Col>
                  <Col><label>Accommodation Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => setVehicle({...vehicle, maccommodationcharges :  x.target.value })}
                  value={vehicle?.maccommodationcharges}/> </Col>
            </Row>
            <Row style={{marginTop  : 15}}>
                  <Col>
                  </Col>
                  <Col><label>Transport Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => setVehicle({...vehicle, mtransportcharges : x.target.value })}
                  value={vehicle?.mtransportcharges}/> </Col>
            </Row>
            </>
           }
          </CardBody>
          <CardFooter>
           <center><Button color={vupdateMode ? "warning" : "primary" } onClick={c => submitform("n")}>{vupdateMode ? "Update" : "Create" }</Button></center>
          </CardFooter>
         </Card>    

        )
    }

    // this is for machines.
     // this will be used to show vehicle entry.    
     const mcard = () =>{ 
      
      return (
        <Card>
        <CardBody>
           <Row>
                   <Col sm="12" md="4">
                   <FormGroup>
                       <label> Catagory </label>
                       <Input type="text" readOnly value={vehicle.category.en} />  
                   </FormGroup>
                   </Col>
                   <Col sm="12" md="4">
                     <FormGroup>
                       <label> Brand </label>
                       <Input type="text" readOnly value={vehicle.bname.en} /> 
                       </FormGroup> 
                   </Col>
                   <Col md="4">
                   <FormGroup>
                       <label>Specification</label>
                       <Input
                       maxLength={10}
                       value={vehicle.notes}
                       placeholder="en"
                       type="text"
                       onChange={h => setVehicle({...vehicle, notes : h.target.value})}
                       />
                   </FormGroup>
                 </Col>
           </Row>
           <Row style={{marginTop  :10, marginBottom : 5}}>
              <Col><u><b>Details </b></u> </Col>
           </Row>      
           <Row style={{marginTop  :5}}>
                   <Col md="3">
                   <FormGroup>
                       <label>Name EN</label>
                       <Input
                        value={vehicle.mname.en}
                       type="text"
                       readOnly  
                       />
                 </FormGroup>
                   </Col>
                  
                   <Col md="3">
                   <FormGroup>
                       <label>اسم</label>
                       <Input
                        value={vehicle.mname.ar}
                        type="text"
                        readOnly  
                       />
                   </FormGroup>
                   </Col>
                   <Col md="3">
                
                </Col>
                   <Col md="3">
                 <FormGroup>
                    <label>Year</label>
                    <Select options={modelyears} styles={customStyles} 
                                   onChange={e=> {
                                     setVehicle({...vehicle, modelyear : e})
                                    }} value={vehicle.modelyear}
                                   />
                   </FormGroup>
                </Col>
           </Row>     
        
         <Row style={{marginTop  :5}}>
           <Col sm = "6">
             <FormGroup>
                <label>Type</label>
                        <Select options={vtypeList.filter(g => g.categoryCode === vehicle.categoryCode).map(f => {
                                             return {
                                               ...f, value : f.typeCode, label : f.typeName.en
                                             }
                                           })} styles={customStyles} 
                          onChange={e=> {
                              setVehicle({...vehicle, vtypeCode : e.value , vtname : e.typeName })
                            }}
                         value={{label : vehicle.vtname.en , value : vehicle.vtypeCode}}
                          />
                </FormGroup>
           </Col>
           <Col sm = "3">
           <FormGroup style={{textAlign : "center"}}>
                <label>Features</label>
                        <br /><label><i className="fa fa-external-link fa-3x" aria-hidden="true" onClick={g => {setShowft(true);}}></i></label>
                </FormGroup>
           </Col>
           <Col sm = "3">
           <FormGroup style={{textAlign : "center"}}>
                <label>Pictures</label>
                        <br /><label><i className="fa fa-external-link fa-3x fa-rotate-180" aria-hidden="true" onClick={g => setClp(!clp)}></i></label>
                </FormGroup>
           </Col>
       </Row>
       <hr/>
       <Collapse isOpen={clp}>
       <p style={{textAlign : "center"}}>*For best results use 1096 x 864, max 500kb size, **do not use same image in single update</p>
       <Row> {/**image aspact ratio is 1.24 */}
              <Col md="5"><img src={showmc()} alt="mainpic" width="400px"  onClick={e => {handleClickM(e)}}/></Col>           
              <Col md="7">
                    <Row><Col><img src={showpc0()} alt="mainpc1" onClick={e => {handleClick1(e)}} /></Col> <Col><img src={showpc1()} alt="mainpc1"  onClick={e => {handleClick2(e)}} /></Col></Row>    
                    <Row><Col><img src={showpc2()} alt="mainpc2"  onClick={e => {handleClick3(e)}} /></Col><Col><img src={showpc3()} alt="mainpc1"  onClick={e => {handleClick4(e)}}/></Col></Row> 
               </Col>           
       </Row>
     
       <hr />
       </Collapse>
       <Row style={{marginTop  :5}}>
           <Col>
           {showVehicle()}
           </Col>
       </Row>
       <hr />
       <Row>
         <Col sm ="12" md="6">
        
             <Row>
             <Col md="6">Full / Thirdparty Insurence</Col>
             <Col md="6">
              <Switch
                 offColor="primary"
                 offText="Thrd"
                 onColor="primary"
                 onText="Full"
                 onChange = {x => setVehicle({...vehicle, insurence : !vehicle.insurence})}
                 value={vehicle.insurence}
               /></Col>
             </Row>
          </Col>
    
         <Col sm ="12" md="6">
           <Row>
           <Col md="6"><span style={{float : "right", paddingTop : 10}}>Fuel</span></Col><Col md="6">
             <Select options={[{value : 0, label : "Petrol" , fr : "Essence", ar : "بنزين"}, {value : 2, label : "Diesel", fr : "Diesel", ar : "ديزل"}, {value : 3, label : "Electric", fr : "Électrique" , ar : "هجكهربائين"},{value : 4, label : "Hybrid", fr : "Hybride" , ar : "هجين"}]} styles={customStyles} 
                          onChange={e=> {
                              setVehicle({...vehicle, fuelname : {en : e.label, fr : e.fr , ar : e.ar} , fuelcode : e.value })
                            }}
                         value={{label : vehicle.fuelname.en , value : vehicle.fuelcode}}
                          />
             </Col>
              
           </Row>
           
         </Col>
       </Row>
       
       <Row style={{marginTop  : 10}}>
         <Col sm ="12" md="6">
           <Row>
           <Col md="6">Color</Col><Col md="6"><Input maxLength={20} style={{marginTop : -5}} type="text" value={vehicle.intcolor} onChange={g => {
                    setVehicle({...vehicle , intcolor : alphaspace.test(g.target.value) ? g.target.value : "", extcolor : alphaspace.test(g.target.value) ? g.target.value : ""})
               }} /></Col>
           </Row>
         </Col>
         <Col sm ="12" md="6">
              <span style={{float : "right", marginTop  : 5}}>Update actual pictures for color details</span>             
         </Col>
       </Row>
       <hr />
       <Row>
         <Col>
         <ul>
           <li>
           With <span style={{color : "red"}}>*</span> are prices for registered users. 
           </li>
           <li>
           Additional Quota Amount is Amount / Kilometer if exceed in any case multiplied by number of times
           </li>
         </ul>
            
                      <Table >
                           <thead >
                               <tr>
                                   <th style={{fontSize : "0.6em"}}>Price For</th>
                                   <th style={{fontSize : "0.6em"}}>Amount</th>
                                   <th style={{fontSize : "0.6em"}}>Amt with Operators</th>
                                   <th style={{fontSize : "0.6em"}}></th>
                                   <th style={{fontSize : "0.6em"}}></th>
                               </tr>
                           </thead>
                           <tbody>
                               <tr>
                                   <td>Hourly</td>
                                   <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.hourly.amt} onChange={g => {
                                        setVehicle({...vehicle , hourly : {...vehicle.hourly, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                      }} /></td>
                                    <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.hourly.wdamt} onChange={g => {
                                         setVehicle({...vehicle , hourly : {...vehicle.hourly, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                   
                               </tr>
                               <tr>
                                   <td>Daily</td>
                                   <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.daily.amt} onChange={g => {
                                        setVehicle({...vehicle , daily : {...vehicle.daily, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                      }} /></td>
                                    <td><Input style={{marginTop : -5}} type="text" maxLength={6} value={vehicle.daily.wdamt} onChange={g => {
                                         setVehicle({...vehicle , daily : {...vehicle.daily, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                        }} /></td>
                                   
                               </tr>
                               <tr>
                                   <td>Monthly</td>
                                   <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.amt} onChange={g => {
                                        setVehicle({...vehicle , monthly : {...vehicle.monthly, amt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                      }} /></td>
                                    <td><Input style={{marginTop : -5}} maxLength={6} type="text" value={vehicle.monthly.wdamt} onChange={g => {
                                         setVehicle({...vehicle , monthly : {...vehicle.monthly, wdamt : numtests.test(g.target.value) ? g.target.value : "0"}})
                                     }} /></td>
                                 
                               </tr>
                              
                           </tbody>
                       </Table>        
                   </Col>
       </Row>
        <hr />
        <Row>
         <Col>
          <label>Additional Info</label>
          <Input type="textarea" maxLength={256} placeholder="About this Listing" 
          onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, en : x.target.value}})}
          value={vehicle.additionalinfo.en}/>

         </Col>
        {/** <Col>
          <label>Additional Info (fr)</label>
          <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
          onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, fr : x.target.value}})}
          value={vehicle.additionalinfo.fr}/>

         </Col>  */}
         <Col>
          <label>Additional Info (Ar)</label>
          <Input type="textarea" maxLength={256} placeholder="حول هذه القائمة" 
          onChange = {x => setVehicle({...vehicle, additionalinfo : {...vehicle.additionalinfo, ar : x.target.value}})}
          value={vehicle.additionalinfo.ar}/>

         </Col>
        </Row>
        <Row style={{marginTop : 15}}>
         <Col>
          <label>Documents Required.</label>
          <Row>
           <Col>   <Input type="textarea" maxLength={256} placeholder="Comma Seperated list" 
          onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, en : x.target.value}, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, en : "-"}})}
          value={vehicle.documentsrequiredresident.en}/></Col>
           {/** 
           <Col>
           <Input type="textarea" maxLength={256} placeholder="256 characters about vehicle listing" 
          onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, fr : x.target.value}})}
          value={vehicle.documentsrequiredresident.fr}/>
          </Col>*/}
           <Col>
           <Input type="textarea" maxLength={256} placeholder="قائمة مفصولة بفواصل" 
          onChange = {x => setVehicle({...vehicle, documentsrequiredresident : {...vehicle.documentsrequiredresident, ar : x.target.value}, documentsrequiredtourist : {...vehicle.documentsrequiredtourist, ar : "-"}})}
          value={vehicle.documentsrequiredresident.ar}/>
          </Col>
          </Row>
         

         </Col>
         </Row>
         
         <Row style={{marginTop  : 15}}>
           <Col>
           <label>security deposit</label><Input maxLength={10} type="text" placeholder="" 
          onChange = {x => setVehicle({...vehicle, securitydeposit :   numtests.test(x.target.value) ? x.target.value : "" })}
          value={vehicle.securitydeposit}/>
           </Col>
           <Col><label>Return Days</label><Input maxLength={3} type="text" placeholder="" 
            onChange = {x => setVehicle({...vehicle, refunddays : numtests.test(x.target.value) ? x.target.value : "" })}
            value={vehicle.refunddays}/> </Col>
         </Row>
         {vehicle?.categoryCode === "2" && 
             <> <Row style={{marginTop  : 15}}>
                  <Col>
                  <label>Certifications</label><Input maxLength={100} type="text" placeholder="" 
                onChange = {x => setVehicle({...vehicle, mcertifications :   x.target.value })}
                value={vehicle?.mcertifications}/>
                  </Col>
                  <Col><label>Mobilization Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => {setVehicle({...vehicle, mobilizationCharges : x.target.value })}}
                  value={vehicle?.mobilizationCharges}/> </Col>
            </Row>
            <Row style={{marginTop  : 15}}>
                  <Col>
                  <label>Food Charges</label><Input maxLength={100} type="text" placeholder="" 
                onChange = {x => setVehicle({...vehicle, mfoodcharges :  x.target.value })}
                value={vehicle?.mfoodcharges}/>
                  </Col>
                  <Col><label>Accommodation Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => setVehicle({...vehicle, maccommodationcharges :  x.target.value })}
                  value={vehicle?.maccommodationcharges}/> </Col>
            </Row>
            <Row style={{marginTop  : 15}}>
                  <Col>
                  </Col>
                  <Col><label>Transport Charges</label><Input maxLength={100} type="text" placeholder="" 
                  onChange = {x => setVehicle({...vehicle, mtransportcharges : x.target.value })}
                  value={vehicle?.mtransportcharges}/> </Col>
            </Row>
            </>
           }
        </CardBody>
        <CardFooter>
         <center><Button color={vupdateMode ? "warning" : "primary" } onClick={c => submitform("n")}>{vupdateMode ? "Update" : "Create" }</Button></center>
        </CardFooter>
       </Card>    

      )
  }
     
    return (
      
        <div className="content">
          {alert}
          {showProcessing && props.Spin } 
           <input
            ref={hiddenFileInputM}
            type="file" 
            accept=".jpg, .jpeg" 
            id="photo" 
            className="visually-hidden"
            onChange={e=> handleImgM(e)}
            hidden/>
           <input
                ref={hiddenFileInput1}
                type="file" 
                accept=".jpg, .jpeg" 
                id="photo" 
                className="visually-hidden"
                onChange={e=> handleImg1(e)}
                hidden/>
           <input
            ref={hiddenFileInput2}
            type="file" 
            accept=".jpg, .jpeg" 
            id="photo" 
            className="visually-hidden"
            onChange={e=> handleImg2(e)}
            hidden/>
            <input
            ref={hiddenFileInput3}
            type="file" 
            accept=".jpg, .jpeg" 
            id="photo" 
            className="visually-hidden"
            onChange={e=> handleImg3(e)}
            hidden/>
            <input
            ref={hiddenFileInput4}
            type="file" 
            accept=".jpg, .jpeg" 
            id="photo" 
            className="visually-hidden"
            onChange={e=> handleImg4(e)}
            hidden/>
          <CreateVInfo vehicle={vehicle} setInfom={setInfom} infom={infom} user={props.user} showVehicle={showVehicle}/>
        
          {showfeaturestable()}
        <Row>
            <Col sm="12" md="6">
       
                <Row>
                  <Col>
                      <Row>
                        <Col><h6>Selected Vehicle</h6></Col>
                        <Col>{showtluid()}</Col>
                      </Row>
                  </Col>
                </Row>
            {vehicle.categoryCode === "1"  && vehiclecard()}
            {vehicle.categoryCode === "2"  &&  mcard()}
            {vehicle.categoryCode === "3"  &&  othercard()}
            </Col>
            <Col sm="12" md="6">
                    {
                       listswap ? 
                      <Mlisting setvUpdateMode={setvUpdateMode} setListswap={setListswap} listswap={listswap} API={props.API} mylist={mylist} setVehicle={setVehicle} isOpen={isOpen} setIsOpen={setIsOpen} toggle={toggle} filtercontrol={filtercontrol}  filterbyt={filterbyt}/> 
                        : 
                      <Vehicles setListswap={setListswap} mylisting={mylisting} listswap={listswap} populatebrands={populatebrands} vehicleList={vehicleList} setFeatureslist={setFeatureslist} vehicle={vehicle} setVehicle={setVehicle} isOpen={isOpen} setIsOpen={setIsOpen} toggle={toggle} filtercontrol={filtercontrol} filterbyt={filterbyt}/>
                    }
            </Col>
        
        </Row>
        </div>
    )
}

export default connect(null, {profileFetch} )(CreateV);